<div class="reward-actions">
  <span class="cost" *ngIf="reward.cost">
    <mat-icon class="icon">stars</mat-icon>{{ reward.cost | number:'': language  }}
  </span>

  <ng-container *ngIf="authenticatedUserService.isGlobalAdmin()">
    <div class="actions">
      <app-slide-toggle
        *ngIf="hasRewardStarted"
        [checked]="reward.enabled"
        [disabled]="isLoading"
        (checkedChange)="changeStatus($event)"
        [matTooltip]="rewardStatusTooltip"
        matTooltipClass="lnr-mat-tooltip-bottom-black"
        [matTooltipPosition]="'above'"
      ></app-slide-toggle>

      <button class="clock" *ngIf="!hasRewardStarted" mat-icon-button>
        <nb-icon icon="clock-outline"></nb-icon>
      </button>

      <button
        (click)="onButtonClick(deleteEvent, false)"
        class="delete"
        mat-icon-button
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>

      <button
        (click)="onButtonClick(editEvent, false)"
        class="edit"
        mat-icon-button
      >
        <nb-icon icon="edit-outline"></nb-icon>
      </button>
    </div>
  </ng-container>
</div>
